const mutations = {
  setLoadingSendEmail(state, loadingSendEmail) {
    state.loadingSendEmail = loadingSendEmail;
  },
  setLoadingSendTestEmail(state, loadingSendTestEmail) {
    state.loadingSendTestEmail = loadingSendTestEmail;
  },
  setTotalRegistrants(state, totalRegistrants) {
    state.totalRegistrants = totalRegistrants;
  }
};

export default mutations;
